/**
 * Extracts the initials from a full name.
 *
 * @param name - The full name from which to extract initials.
 * @returns The initials of the provided name. If the name contains only one word,
 *          it returns the first character of that word. If the name contains two words,
 *          it returns the first character of each word.
 */
export const getInitials = (name: string) => {
	const parts = name.trim().split(/\s+/).filter(Boolean);

	if (parts.length === 0) return "";

	if (parts.length === 1) {
		return parts[0].charAt(0).toUpperCase();
	}

	return parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase();
};
